<nav id="navbar">
  <div class="nav-container">
    <div class="logo">
      <img src="/images/landing/logo.svg" alt="Wealthlane" class="logo-img">
      <span>ealthlane</span>
    </div>
    <ul class="nav-links">
      <li><a  (click)="scrollTo('constat')">Constat</a></li>
      <li><a  (click)="scrollTo('solution')">Solution</a></li>
      <li><a  (click)="scrollTo('roi')">Revenus</a></li>
      <li><a  (click)="scrollTo('processus')">Fonctionnement</a></li>
      <li><a  (click)="scrollTo('decouvrir')">Découvrir</a></li>
      <li><a  (click)="scrollTo('accompagnement')">Accompagnement</a></li>
      <li><a  (click)="openPricingPopup()">Tarifs</a></li>
    </ul>
    <a  class="nav-account-btn" [routerLink]="'/login'">Mon compte</a>
  </div>
</nav>

